define(["require", "exports", "jquery", "knockout", "log", "../../utils/tools", "../../utils/kendoUtils", "../../models/UserContext", "../../models/CPCustomerUserModel", "../../models/BulkEditCustomerUserModel", "../../utils/LookupDataSources", "../import/importCPUsers"], function (require, exports, $, ko, log, tools, KendoUtils, UserContext, CPCustomerUserModel, BulkEditCustomerUserModel, LookupDataSources, ImportCPUsers) {
    "use strict";
    var CPCustomerUserActions = /** @class */ (function () {
        function CPCustomerUserActions(customerProfileId, initGridCallback) {
            this.userCanViewCPCustomerUser = ko.observable(UserContext.hasAccess("Admin,CPCustomerUsers.View,CPCustomerUsers.Edit,CPCustomerUsers.Delete"));
            this.userCanEditCPCustomerUser = ko.observable(UserContext.hasAccess("Admin,CPCustomerUsers.Edit,CPCustomerUsers.Delete"));
            this.userCanDeleteCPCustomerUser = ko.observable(UserContext.hasAccess("Admin,CPCustomerUsers.Delete"));
            this.filterByAny = ko.observable();
            this.editModel = ko.observable(new CPCustomerUserModel());
            this.bulkEditCustomerUserModel = ko.observable(new BulkEditCustomerUserModel());
            this.sendToEmail = ko.observable("");
            this.importCPUsers = new ImportCPUsers();
            this.isLookupDataLoaded = false;
            this.isInitGridRequested = false;
            var self = this;
            self.customerProfileId = customerProfileId;
            if (!self.customerProfileId) {
                self.userCanEditCPCustomerUser(false);
            }
            if (self.userCanViewCPCustomerUser()) {
                var lookupData = self.getLookupData();
                $.when(lookupData).done(function () {
                    self.cpCustomerUsersStructure = self.customerUserLookupList.GridStructures.CPCustomerUsersStructure;
                    self.initExportDataSource();
                    self.isLookupDataLoaded = true;
                    if (self.isInitGridRequested) {
                        self.initGrid();
                    }
                    if (initGridCallback) {
                        initGridCallback(self);
                    }
                });
            }
        }
        CPCustomerUserActions.prototype.initGridOnShow = function () {
            var self = this;
            if (self.userCanViewCPCustomerUser()) {
                if (!this.isLookupDataLoaded) {
                    this.isInitGridRequested = true;
                }
                else {
                    this.initGrid();
                }
            }
        };
        CPCustomerUserActions.prototype.initExportDataSource = function () {
            var self = this;
            self.customerUsersDataSourceOptions = {
                transport: {
                    read: {
                        url: "/CPCustomerUsers/GetCPCustomerUsers",
                        type: "POST",
                        data: function () {
                            var data = {};
                            data.customerProfileId = self.customerProfileId ? self.customerProfileId : -1;
                            return data;
                        },
                        dataType: "json"
                    }
                },
                schema: {
                    model: self.cpCustomerUsersStructure.model,
                    data: function (response) { return response.Data; },
                    total: "Total",
                    aggregates: "Aggregates",
                    errors: "Errors"
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                serverAggregates: false
            };
            self.customerUsersDataSource = new kendo.data.DataSource(self.customerUsersDataSourceOptions);
        };
        CPCustomerUserActions.prototype.getLookupData = function () {
            var self = this;
            return tools.ajaxGet({
                url: "/CPCustomerUsers/GetLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.customerUserLookupList = data.Data.lookupLists;
                    }
                }
            });
        };
        CPCustomerUserActions.prototype.initGrid = function () {
            var self = this;
            var gridId = "tblCustomerUsers";
            var columns = self.cpCustomerUsersStructure.columns;
            //add actions column
            var actions = {
                field: "",
                width: "150px",
                template: function (dataItem) {
                    var html = "";
                    if (self.userCanEditCPCustomerUser()) {
                        html += "<a class=\"btn btn-sm btn-yellow btn-edit\" title=\"Edit User\" href=\"#\"><i class=\"fa fa-edit\"></i></a>";
                        html += "&nbsp;<a class=\"btn btn-sm btn-info btn-send\" title=\"Resend Invitation\" href=\"#\"><i class=\"fa fa-paper-plane-o\"></i></a>";
                        html += "&nbsp;<a class=\"btn btn-sm btn-info mat-icon-btn btn-send-app\" title=\"Send SoftPhone App Credentials\" href=\"#\"><i class=\"material-icons\">computer</i></a>";
                        html += "&nbsp;<a class=\"btn btn-sm btn-success btn-impersonate\" title=\"Impersonate User\" href=\"#\"><i class=\"fa fa-sign-in\"></i></a>";
                    }
                    if (self.userCanDeleteCPCustomerUser()) {
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" title="Delete User" href="#"><i class="fa fa-trash-o "></i></button>';
                    }
                    return html;
                }
            };
            columns.unshift(actions);
            self.customerUserTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/CPCustomerUsers/GetCPCustomerUsers",
                            type: "POST",
                            data: function () {
                                var data = {};
                                data.customerProfileId = self.customerProfileId ? self.customerProfileId : -1;
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: self.cpCustomerUsersStructure.model
                    }
                },
                gridOptions: {
                    //toolbar: kendo.template($("#employee-toolbar-template").html()),
                    columns: columns,
                    // height: 500,
                    resizable: true,
                    reorderable: true,
                    //mobile: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row",
                        extra: false
                    },
                    height: 500,
                    detailInit: self.initUserDevicesGrid.bind(self)
                },
                gridId: gridId,
                showPagerOnTop: false,
                enableExport: {
                    entityName: "CpCustomerUser",
                    title: "Customer Users",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: true,
                    customDataAttributes: 'data-name="#=UserName#"'
                },
                controller: self
            };
            self.customerUserTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.customerUserTable.getGridData().dataSource.read();
            });
            $("#" + gridId + " tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.editCustomerUser(data.Id);
                event.preventDefault();
            }).on("click", ".btn-send", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.sendInvitationConfirm(data.UserName);
                event.preventDefault();
            }).on("click", ".btn-send-app", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.sendCustomerCounterPathCredentialsConfirm(data.Id, data.Email);
                event.preventDefault();
            }).on("click", ".btn-impersonate", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.impersonateConfirm(data.UserName, data.CustomerProfileId);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.deleteCustomerUserConfirm(data.Id, "".concat(data.FirstName, " ").concat(data.LastName));
                event.preventDefault();
            });
        };
        CPCustomerUserActions.prototype.initUserDevicesGrid = function (e) {
            var self = this;
            var gridStructure = self.customerUserLookupList.GridStructures.CPCustomerUserDevicesStructure;
            if (!e.data.CcsUserId) {
                return;
            }
            var grid = new KendoUtils.KendoUtils();
            $("<div/>").attr('id', e.data.CcsUserId).appendTo(e.detailCell);
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/CPCustomerUsers/GetCPCustomerUserDevices",
                            type: "POST",
                            data: function () {
                                var data = {};
                                data.ccsUserId = e.data.CcsUserId;
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model
                    }
                },
                gridOptions: {
                    resizable: true,
                    columns: gridStructure.columns
                },
                gridId: e.data.CcsUserId,
                showPagerOnTop: true
            };
            grid.initGrid(gridOptions);
        };
        CPCustomerUserActions.prototype.editCustomerUser = function (id) {
            var self = this;
            var title = "Add New Customer User";
            if (!isNaN(id)) {
                title = "Edit Customer User";
            }
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalClass: "full-width",
                modalOptions: {},
                save: function (event, modal) {
                    self.editModel().RoleId(self.commissionRoleStatusDropdown.value());
                    //validate form
                    if (!self.editModel().Email()) {
                        tools.error("User Email is a required field");
                        return;
                    }
                    if (!self.editModel().FirstName()) {
                        tools.error("First Name is a required field");
                        return;
                    }
                    if (!self.editModel().LastName()) {
                        tools.error("Last Name is a required field");
                        return;
                    }
                    if (!tools.isValidEmail(self.editModel().Email())) {
                        tools.error("Email address is not valid");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveCustomerUser(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    var lookupData = null;
                    if (!isNaN(id)) {
                        getModelCall = tools.ajaxGet({
                            url: "/CPCustomerUsers/GetCPCustomerUserById",
                            data: { id: id },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new CPCustomerUserModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new CPCustomerUserModel());
                        self.editModel().CustomerProfileId(self.customerProfileId);
                    }
                    $.when(getModelCall, lookupData).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'cpcustomeruser-edit-template', data: $root }\"></div>");
                        ko.applyBindings(self, modal);
                        var parentContainer = $(".modal-body", modal);
                        var lookupDataSources = new LookupDataSources();
                        var cpRolesDS = lookupDataSources.createLookupDataSource("CPRoles", {
                            dataFunction: function () {
                                var data = {};
                                data.customerProfileId = self.customerProfileId;
                                return data;
                            },
                        });
                        self.commissionRoleStatusDropdown = $("input[name=RoleId]", modal).kendoDropDownList({
                            dataSource: cpRolesDS,
                            dataTextField: "Text",
                            dataValueField: "Id",
                            valuePrimitive: true,
                            filter: "contains",
                            popup: {
                                appendTo: parentContainer
                            }
                        }).data("kendoDropDownList");
                        if (self.commissionRoleStatusDropdown) {
                            self.commissionRoleStatusDropdown.value(self.editModel().RoleId());
                        }
                    });
                }
            });
        };
        CPCustomerUserActions.prototype.saveCustomerUser = function (btn, modal) {
            var self = this;
            var data = tools.modelToFormData(self.editModel());
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CPCustomerUsers/SaveCPCustomerUser",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    if (self.afterSuccess) {
                        self.afterSuccess();
                    }
                    if (self.customerUserTable) {
                        self.customerUserTable.getGridData().dataSource.read();
                    }
                    $(modal).modal("hide");
                    return;
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        CPCustomerUserActions.prototype.deleteCustomerUser = function (id) {
            var self = this;
            var data = {
                id: id
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CPCustomerUsers/DeleteCPCustomerProfileConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Customer User deleted successfully");
                    if (self.afterSuccess) {
                        self.afterSuccess();
                    }
                    if (self.customerUserTable) {
                        self.customerUserTable.getGridData().dataSource.read();
                    }
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        CPCustomerUserActions.prototype.deleteCustomerUserConfirm = function (id, name) {
            var self = this;
            tools.confirmModal({
                title: "Delete Customer User",
                text: "Are you sure you want to delete Customer User " + name + "?",
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.deleteCustomerUser(id);
            });
        };
        CPCustomerUserActions.prototype.confirmUpdateSystemRoles = function () {
            var self = this;
            tools.confirmModal({
                title: "Update Customer Portal System Roles",
                text: "Are you sure you want to update customer portal system roles?",
                buttonTitle: "Update",
                type: "info",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.updateSystemRoles();
            });
        };
        CPCustomerUserActions.prototype.updateSystemRoles = function () {
            var self = this;
            tools.ajaxGet({
                url: "/CPCustomerUsers/UpdatePrimaryRoles",
            }).done(function (result) {
                if (result.Success) {
                    tools.success("System roles has been updated successfully");
                    if (self.afterSuccess) {
                        self.afterSuccess();
                    }
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        CPCustomerUserActions.prototype.sendInvitation = function (email) {
            var self = this;
            tools.ajaxGet({
                url: "/CPCustomerUsers/SendInvitation?email=" + email
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Invitation sent successfully");
                    if (self.afterSuccess) {
                        self.afterSuccess();
                    }
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        CPCustomerUserActions.prototype.impersonate = function (email, profileId) {
            var self = this;
            tools.ajaxGet({
                url: "/CPCustomerUsers/GetImpersonateToken?email=".concat(email, "&profileId=").concat(profileId)
            }).done(function (result) {
                if (result.Success) {
                    log.log("impersonate success");
                    setTimeout(function () {
                        self.impersonateAccessLink(result.Data);
                    });
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        CPCustomerUserActions.prototype.bulkSendCustomerCounterPathCredentials = function () {
            var self = this;
            var listOfIds = [];
            $("#tblCustomerUsers .check-row:checked").each(function (index, element) {
                listOfIds.push($(element).data());
            });
            if (listOfIds.length > 0 && listOfIds.length <= 1000) {
                self.onBulkSendCustomerCounterPathCredentials(listOfIds);
            }
            else if (listOfIds.length > 1000) {
                tools.error("You can edit only 1000 items at a time");
            }
            else {
                tools.error("Please select at least one item to edit");
            }
        };
        CPCustomerUserActions.prototype.onBulkSendCustomerCounterPathCredentials = function (listOfIds) {
            var extName = listOfIds.map(function (item) {
                return item.name;
            });
            var ids = listOfIds.map(function (item) {
                return item.id;
            });
            tools.confirmModal({
                title: "Send CounterPath Credentials?",
                html: "Are you sure you want to send Send CounterPath Credentials for clients?<br/>" + extName.join(", "),
                buttonTitle: "Send",
                type: "info",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                tools.ajaxPost({
                    url: "/CPCustomerUsers/SendCounterPathToCustomers",
                    data: { ids: ids },
                    success: function (result) {
                        if (result.Success) {
                            tools.success("Email sent successfully.");
                        }
                    }
                });
            });
        };
        CPCustomerUserActions.prototype.sendCustomerCounterPathCredentialsConfirm = function (id, emailAddress) {
            var self = this;
            tools.editModal({
                title: "Send CounterPath Credentials?",
                text: "Are you sure you want to send Send CounterPath Credentials for client?",
                buttonTitle: "Send",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    if (!self.sendToEmail()) {
                        tools.error("Email address is required");
                        return;
                    }
                    if (!tools.isValidEmail(self.sendToEmail())) {
                        tools.error("Email address is not valid");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    tools.ajaxPost({
                        url: "/CPCustomerUsers/SendCounterPathToCustomer",
                        data: { id: id, emailAddress: self.sendToEmail() },
                        success: function (result) {
                            if (result.Success) {
                                $(modal).modal("hide");
                                tools.success("Email sent successfully.");
                            }
                        }
                    });
                },
                opened: function (modal) {
                    self.sendToEmail(emailAddress);
                    $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'send-counterpath-credentials-template', data: $root }\"></div>");
                    ko.applyBindings(self, modal);
                }
            });
        };
        CPCustomerUserActions.prototype.sendInvitationConfirm = function (email) {
            var self = this;
            tools.confirmModal({
                title: "Send Invitation to User",
                text: "Are you sure you want to send invitation to User " + email + "?",
                buttonTitle: "Send",
                type: "info",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.sendInvitation(email);
            });
        };
        CPCustomerUserActions.prototype.impersonateConfirm = function (email, profileId) {
            var self = this;
            tools.confirmModal({
                title: "Impersonate User",
                text: "Are you sure you want to log in to customer portal as " + email + "?",
                buttonTitle: "Request Access",
                type: "info",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.impersonate(email, profileId);
            });
        };
        CPCustomerUserActions.prototype.impersonateAccessLink = function (url) {
            tools.alertModal({
                title: "Impersonate User",
                html: "<a class=\"btn btn-info\" href=\"".concat(url, "\" target=\"_blank\">Log in to Customer Portal</a>"),
                buttonTitle: "Close",
                type: "info",
                modalOptions: {},
                open: function (modal) {
                    $('a', modal).on("click", function () {
                        $(modal).modal("hide");
                    });
                }
            });
        };
        CPCustomerUserActions.prototype.bulkEdit = function () {
            var self = this;
            var listOfIds = [];
            $("#tblCustomerUsers .check-row:checked").each(function () {
                listOfIds.push($(this).data());
            });
            if (listOfIds.length > 0 && listOfIds.length <= 1000) {
                self.bulkEditCustomerUsers(listOfIds);
            }
            else if (listOfIds.length > 1000) {
                tools.error("You can edit only 1000 items at a time");
            }
            else {
                tools.error("Please select at least one item to edit");
            }
        };
        CPCustomerUserActions.prototype.bulkEditCustomerUsers = function (users) {
            var self = this;
            self.bulkEditCustomerUserModel(new BulkEditCustomerUserModel());
            var customerUserIds = ko.utils.arrayMap(users, function (item) {
                return item.id;
            });
            // console.log(users);
            self.bulkEditCustomerUserModel().CustomerProfileId(self.customerProfileId);
            self.bulkEditCustomerUserModel().CustomerUsers(users);
            self.bulkEditCustomerUserModel().CustomerUserIds(customerUserIds);
            tools.editModal({
                title: "Customer Users Bulk Edit",
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    $(event.currentTarget).button("loading");
                    self.saveBulkEditCustomerUsers(event.currentTarget, modal);
                },
                opened: function (modal) {
                    $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'bulk-cp-customer-user-edit-template', data: bulkEditCustomerUserModel }\"></div>");
                    ko.applyBindings(self, modal);
                }
            });
        };
        CPCustomerUserActions.prototype.saveBulkEditCustomerUsers = function (btn, modal) {
            var self = this;
            var obj = ko.mapping.toJS(self.bulkEditCustomerUserModel);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CPCustomerUsers/SaveBulkEditCustomerUsers",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    if (self.afterSuccess) {
                        self.afterSuccess();
                    }
                    if (result.Data && result.Data.Errors && result.Data.Errors.length > 0) {
                        tools.error(result.Data.Errors.join('<br/>'));
                    }
                    if (self.customerUserTable) {
                        self.customerUserTable.getGridData().dataSource.read();
                    }
                    /*if (self.saveCustomerCallback) {
                        self.saveCustomerCallback(result.Data);
                    }*/
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        CPCustomerUserActions.prototype.import = function () {
            var self = this;
            self.importCPUsers.import(self.customerProfileId, function () {
                if (self.customerUserTable) {
                    self.customerUserTable.getGridData().dataSource.read();
                }
            });
        };
        return CPCustomerUserActions;
    }());
    return CPCustomerUserActions;
});
//# sourceMappingURL=customerUserActions.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customerPortalAdmin/customerUserActions.js
// module id = 43
// module chunks = 2